import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Hexapi from "../../utility/HexAPI/Hexapi";
import { showConfirm } from "../../utility/showconfirm";
import { IoMdCheckmark } from "react-icons/io";

export const RSVP = ({ userID, meetingID, curRSVPAction ,GetMeetingDetails}) => {
  const [rsvp, setRsvp] = useState(curRSVPAction);
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);

  const openModal = (action) => {
    if (rsvp == action) return;

    setActionType(action);
    setRemarks("");
    setShowModal(true);
  };

  const submitRSVP = async () => {
    if (actionType == "-1" && !remarks.trim()) {
      showConfirm({
        content: "Please enter remarks for RSVP No.",
        hideCancel: true,
      });
      return;
    }

    setLoading(true);
 
    const query = `HRApp_Droid_Proc_User_Meeting_RSVPAction_Submit
      @UserID='${userID}',
      @MeetingID='${meetingID}',
      @RSVPActionType='${actionType}',
      @Remarks='${remarks}'`;

    try {
      const resp = await Hexapi({ query, queryArr: [] });
      console.log("RSVP Response:", resp);
if(resp && resp[""] && resp[""][0]){
if(resp && resp[""] && resp[""][0].command == 1){
  setShowModal(false);
 await showConfirm({
    content:resp[""][0].msg,
    hideCancel:true
  }).then(()=>{
    GetMeetingDetails(true)
  setRsvp(actionType);
      setShowModal(false);
  })

}else{
showConfirm({
    content:resp[""][0].msg,
    hideCancel:true
  })
}
}
      
    } catch (err) {
      console.error("RSVP Submit Error:", err);
      alert("Failed to submit RSVP. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        position: "sticky",
        zIndex: 1,
        bottom: "10px",
        margin: "10px",
      }}
    >
      <div style={{ backgroundColor: "#ded2d2", width: "100%", padding: "8px" , borderRadius:"4px"}}>
        <center>
          <p style={{fontWeight:600}}>
              You will be attending this meeting  
          </p>
        </center>

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <p
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "2px",
              fontWeight: 700,
              color:"red"
            }}
            onClick={() => openModal("-1")}
          >
            No {rsvp == "-1" && <IoMdCheckmark color="red" size={22} />}
          </p>

          <p
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
          fontWeight: 700,
              color:"green"
            }}
            onClick={() => openModal("1")}
          >
            Yes {rsvp == "1" && <IoMdCheckmark color="green" size={22} />}
          </p>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Body>
 <div style={{color:"red", fontWeight:600 , fontSize:""}}>
            {actionType == "1" ? "RSVP Yes" : "RSVP No"}
         </div>
          <p>
            {actionType == "1"
              ? "You will be attending this meeting"
              : "You will not be attending this meeting"}
          </p>

          <Form.Group>
            <Form.Label>Remarks</Form.Label>
            <Form.Control
              as="textarea"
              rows={1}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer style={{display:"flex", justifyContent:"center"}}>
         
          <Button variant="primary" onClick={submitRSVP} disabled={loading}>
            {loading ? "Updating..." : "OK"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};